import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ModalDialog } from '@kanos/ui';
import { ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { closedBy } from './dialogs.js';
import { startSignIn } from './session.js';
/** Time a form asked for after a second factor needs at least: filling it in, then saving. */
const FORM_MINUTES = 3;
/**
 * Whether the session's last second factor (ADR-005) still counts long enough to fill a form
 * and save it - so a long form is asked for it before, not after, and nothing typed is lost.
 * The API decides on saving anyway; this only spares the person a lost form.
 */
export function stepUpLasts(validUntil, now = Date.now()) {
    return validUntil !== null && Date.parse(validUntil) - now >= FORM_MINUTES * 60_000;
}
/**
 * Asks for the second factor before a form that needs it: off to the identity provider, back to
 * `returnTo` - an address that opens the form again.
 */
export function StepUpFirst({ title, description, returnTo, onClose, }) {
    const [leaving, setLeaving] = useState(false);
    return (_jsx(ModalDialog, { title: title, description: description, isOpen: true, onOpenChange: closedBy(onClose), children: (close) => (_jsxs("div", { className: "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", children: [_jsx(Button, { variant: "quiet", onPress: close, children: "Abbrechen" }), _jsxs(Button, { isPending: leaving, onPress: () => {
                        setLeaving(true);
                        startSignIn(returnTo, 'step-up');
                    }, children: [_jsx(ShieldCheck, { "aria-hidden": true, className: "size-4" }), "Mit zweitem Faktor best\u00E4tigen"] })] })) }));
}
//# sourceMappingURL=step-up.js.map